export enum EShouldRegisterUserMetaStatus {
  notFound = 'NOT_FOUND',
  invalidPhone = 'INVALID_PHONE',
}

export const timeToAllowSendingCode = 31 * 1000

export const INN_LENGTH_OF_INDIVIDUAL_ENTREPRENEUR = 12
export const INN_LENGTH_OF_LEGAL_COMPANY = 10
export const OPEN_CHANGE_ACTIVE_ORGANIZATION_MODAL_QUERY_PARAMETER = 'withChangeActiveOrganisationModal'
